<template>
  <div class="btn-group btn-group-sm">
    <a class="btn btn-info" title="Download"
      target="_blank"
      :class="{ '-nested-comp-open-btn': isDisplayRowVisible }"
      :href="DownloadURL">
      <i class="fa fa-download"></i>
    </a>
    <button v-if="(can_access('report','modify'))" class="btn btn-danger" title="Delete Report" @click="editReport('delete')"><i class="fa fa-trash"></i></button>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested','refresh'],
  data(){
      return {
          DownloadURL : '',
      }
  },
  components: {},
  mixins: [common],
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
    this.loadURL();
  },
  computed: {
    isDisplayRowVisible () {
      if (this.nested.comp !== 'Reports') return
      return this.nested.visible
    },
  },
  methods: {
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    loadURL(){
        this.DownloadURL = this.get_baseURL() +'download_report?api_token='+ window.localStorage.getItem('auth_token')+'&filename='+this.row.filename;
        //console.log(this.DownloadURL)
    },
    editReport(type){
      if(type=='delete'){
        if(confirm("Do you really want to delete?")){
          this.call_axios('delete_report?filename='+this.row.filename).then(res => {this.refresh();});
        }else return;
      }
    }
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
